// extracted by mini-css-extract-plugin
export default {"container":"ImportAmendments_container__5B9kT","buttonWrapper":"ImportAmendments_buttonWrapper__1z7GD","bulkActions":"ImportAmendments_bulkActions__p0Z4P"};